<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2" @click="modals" v-if="ERP.isPermission(7004001)">添加人员</el-button>

    <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="ERP.isPermission(7004004)">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select>

    <!-- <el-select v-model="value2" filterable placeholder="请选择归属" class="kuan">
      <el-option
        key="0"
        label="全部"
        value="0">
      </el-option>
      <el-option
        v-for="item in options2"
        :key="item.id"
        :label="item.jname"
        :value="item.id">
      </el-option> -->
    <!-- </el-select> -->
    <el-input size="mini" class="search" placeholder="请输入账号" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">账号</th>
            <!-- <th class="text-left">角色名称</th> -->
            <th class="text-left">组织权限</th>
            <th class="text-left">组织信息</th>
            <!-- <th class="text-left">归属</th> -->
            <th class="text-left">手机号</th>
            <!-- <th class="text-left">创建人</th> -->
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.user}}</td>
            <!-- <td >{{item.administrators}}</td> -->
            <td >{{item.jnames}}-{{item.jname}}</td>
            <td >{{item.company_name}}</td>
            <!-- <td >{{item.jnames}}</td> -->
            <td >{{item.phone}}</td>
            <!-- <td >{{item.adname}}</td> -->
            <td >{{item.dade}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="tjqx( item.id,item.jnames,item.administrators,item.company_name,item.jname )" v-if="ERP.isPermission(7004005)">多权限</div>
              <div style="color: #1867c0;margin-left: 5px;cursor: pointer;" @click="xiugai( item.id,item.jnames )" v-if="ERP.isPermission(7004002)">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )" v-if="ERP.isPermission(7004003)">删除</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="80px" :model="dades">
            <!-- <el-form-item label="角色名称">
              <el-input v-model="dades.administrators"></el-input>
            </el-form-item> -->

            <el-form-item label="组织信息">
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-if="cs == 2" disabled @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-else @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>


             <el-form-item label="选择架构">
              <el-select v-model="opdadeval[0].valid" filterable placeholder="请选择" @change="changes1(opdadeval[0].valid,0)">
                <el-option
                  v-for="item in opdade[0]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[1].valid" placeholder="请选择" v-if="opdade[1][0]['id']" @change="changes1(opdadeval[1].valid,1)">
                <el-option
                  v-for="item in opdade[1]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[2].valid"  placeholder="请选择" v-if="opdade[2][0]['id']" @change="changes1(opdadeval[2].valid,2)">
                <el-option
                  v-for="item in opdade[2]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[3].valid" style="margin-top: 3.6px;" placeholder="请选择" v-if="opdade[3][0]['id']" @change="changes1(opdadeval[3].valid,3)">
                <el-option
                  v-for="item in opdade[3]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[4].valid"  placeholder="请选择" v-if="opdade[4][0]['id']" @change="changes1(opdadeval[4].valid,4)">
                <el-option
                  v-for="item in opdade[4]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[5].valid" placeholder="请选择" v-if="opdade[5][0]['id']" @change="changes1(opdadeval[5].valid,5)">
                <el-option
                  v-for="item in opdade[5]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>


            <!-- <span class="gshu">归属:{{cs}}</span> -->
            <el-form-item label="人员权限">
              <el-select v-model="dades.jurisdiction_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="登录账号">
              <el-input v-model="dades.user"></el-input>
            </el-form-item>
            <el-form-item label="登录密码">
              <el-input v-model="dades.pwd" show-password></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="dades.phone"></el-input>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

    <Modal
        v-model="modal2"
        ok-text="保存"
        width="800"
        title="编辑添加多权限"
        @on-ok="oks">
        <div>
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="角色信息">
              姓名：{{modal2s.jnames}}，组织：{{modal2s.company_name}}
              <br>当前权限（归属：{{modal2s.administrators}}，权限：{{modal2s.jname}}）
            </el-form-item>
            <div v-for="(it,index) in formDynamic" :key="it.index" v-if="it.status">
              <el-form-item :label="'归属' + index">
                <el-select v-model="formDynamic[index].value" filterable placeholder="请选择" @change="changes(it.value,index)">
                  <el-option
                    v-for="item in options2"
                    :key="item.id"
                    :label="item.jname"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="'权限' + index">
                <el-select v-model="formDynamic[index].value1" filterable placeholder="请选择">
                  <el-option
                    v-for="item in optionsqx[index]"
                    :key="item.id"
                    :label="item.jname"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-button plain @click="handleRemove(index)">删除</el-button>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button plain @click="handleAdd()">+ 添加</el-button>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

</div>

</template>

<script>
export default {
  name: 'JuserindexAdd',
  data () {
    return {
      index:0,
      opdadeval:[
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        }
      ],
      opdade:[
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }]
      ],
      formDynamic: [
        {
          value: '',
          value1: '',
          index: 0,
          status: 1
        },
      ],
      optionsqx:[
        [
          {
            id:'',
            jname:'',
          }
        ]
      ],
      modal1:false,
      modal2:false,
      dades: {
        id:'',
        login_name:'',
        administrators:'',
        user: '',
        pwd:'',
        phone:'',
        company_id: '',
        jurisdiction_id:'',
        opdadeval:[],
        opdade:[],
        opdade1:[],
      },
      options: [
        {
          value: '',
          label: ''
        },],
      options1: [
      {
        value: '',
        label: ''
      },],
      options2: [
      {
        value: '',
        label: ''
      },],
      value: '',
      value2: '',
      anxiu:'',
      input1: '',
      desserts: '',
      total:0,
      page:12,
      search:'',
      cs:'',
      idsa:'',
      modal2s:[
        {
          id:'',
          administrators:'',
          jnames:'',
          company_name:'',
          jname:'',
        }
      ]
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    ERP.showLoading()
    this.$Loading.start();
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value2 = backdata.data[0];//开启不查全部
        this.value2 = 0;
        this.$myhttp.get('admin/Jurisdiction?search='+ this.search + '&id=1' +'&company='+this.value +'&company1='+this.value2+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          ERP.hideLoading()
      });
    });
    //加载公司列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options2 = backdata.data[1];
        this.idsa = backdata.data[2];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //根据组织查归属
    changesa(e){
      // console.log(e);
      this.$Loading.start();
      this.$myhttp.get('admin/getJlistOps?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade[0]=backdata.data[0];
        var bc = backdata.data[0];
        this.$forceUpdate();
        this.$myhttp.get('admin/sxjm',{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.opdade[0] = bc;
            this.opdadeval[0].valid="";
          });
        this.$Loading.finish();
      });
    },
    //监听选择归属改变
    changes1(e,op){
      this.$Loading.start();
      // console.log(e);//id
      // console.log(op);//属于哪一个数组
      var ops = op+1;
      // console.log(ops);
      this.$myhttp.get('admin/getJlistOp?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        if(backdata.data[1] == 200){
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
          this.opdade[ops] = backdata.data[0];
          this.options1 = backdata.data[2];
        }else{
          // this.options1=[{id: '',jname: ''}];
          this.options1 = backdata.data[2];
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
       }
       this.dades.jurisdiction_id = '';
       this.$Loading.finish();
      //  console.log(this.opdadeval);
       this.$forceUpdate();
      });
    },
    //动态改变权限
    changes(id,key){
      this.$Loading.start();
      this.$myhttp.get('admin/getmultiPower?id='+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.optionsqx[key] = backdata.data[0];
          this.$Loading.finish();
          this.$forceUpdate();
      });
    },
    handleAdd(){
      this.index++;
      this.formDynamic.push({
        value: '',
        value1: '',
        index: this.index,
        status: 1
      });
      this.optionsqx[this.index] = [{id:'',jname:'',}]
    },
    handleRemove(index){
      this.formDynamic[index].status = 0;
    },
    //多权限保存
    oks(){
      this.$Loading.start();
      var date = [this.formDynamic,this.modal2s.id,this.optionsqx];
      this.$myhttp.post('admin/multiPower',date,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0]==200){
            this.$Message.success(backdata.data[1]);
          }
          this.$Loading.finish();
      });
    },
    //点击多权限
    tjqx(e,jnames,name,company_name,jname){
      this.$Loading.start();
      this.$myhttp.get('admin/getmultiPowerAll?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data['code'] == 0){
            this.formDynamic = [{value: '',value1: '',index: 0,status: 1},];
            this.optionsqx = [[{id:'',jname:'',}]];
            this.modal2 = true;
            this.$Loading.finish();
            return false;
          }
          if(backdata.data['code'] == 200){
            this.formDynamic = backdata.data[0];
            this.optionsqx = backdata.data[1];
            this.modal2 = true;
          }else{
            this.$Message.error('操作失败!');
          }
          this.$Loading.finish();
      });
      this.modal2s.id = e;
      this.modal2s.administrators = jnames;
      this.modal2s.jnames = name;
      this.modal2s.jname = jname;
      this.modal2s.company_name = company_name;

    },
    //修改查询
    xiugai(e,jnames){
      this.anxiu="修改";
      this.cs = jnames;
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/getJuserupdate?id='+e+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.dades = backdata.data[0][0];
        this.options1 = backdata.data[1];

        this.opdadeval[0].valid = backdata.data[2];
        this.opdade[0] = backdata.data[3];
        this.opdade[1] = [{id:'',jname:'',}];
        this.opdade[2] = [{id:'',jname:'',}];
        this.opdade[3] = [{id:'',jname:'',}];
        this.opdade[4] = [{id:'',jname:'',}];
        this.opdade[5] = [{id:'',jname:'',}];

        // this.opdadeval = backdata.data[2];
        // this.opdade = backdata.data[3];

        this.$Loading.finish();
        this.$forceUpdate();
        this.modal1 = true;
      });
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlistuserget?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.cs = backdata.data[2];
      });
    },
     //保存权限
    ok(){
      if(this.dades.company_id == ""){
        this.$Message.error('请选择权限信息!');
        return false;
      }
      if(this.dades.jurisdiction_id == ""){
        this.$Message.error('请选择权限!');
        return false;
      }
      if(this.dades.user == ""){
        this.$Message.error('登录账号不能为空!');
        return false;
      }
      if(this.dades.pwd == ""){
        this.$Message.error('登录密码不能为空!');
        return false;
      }
      if(this.dades.phone == ""){
        this.$Message.error('登录电话不能为空!');
        return false;
      }
      this.$Loading.start();
      // this.datas.administrators = this.dades.user;
      var login = window.localStorage.getItem('login');
      this.dades.login_name = login;
      this.dades.opdadeval = this.opdadeval;
      this.dades.opdade = this.options1;
      this.dades.opdade1 = this.opdade;
      this.$myhttp.post('admin/Jindexsuseradd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/Jurisdiction?id=1' +'&company='+this.value +'&company1='+this.value2+'&t='+t,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades = {id:'',administrators:'',user: '',pwd:'',phone:'',company_id: '',jurisdiction_id:'',opdadeval:[],opdade:[],opdade1:[],};
          }else{
             if(backdata.data[0] == 2){
               this.$Message.error(backdata.data[1]);
             }else{
               this.$Message.error('编辑失败!');
             }
          }
          this.$Loading.finish();
      });
    },
    //点击添加
    modals(){
      this.$Loading.start();
      this.anxiu = "保存";
      //加载基本信息
      if(this.dades.id != ''){
        this.dades = {id:'',administrators:'',user: '',pwd:'',phone:'',company_id: '',jurisdiction_id:'',opdadeval:[],opdade:[],opdade1:[],};
        this.opdade[1] = [{id:'',jname:'',}];
        this.opdade[2] = [{id:'',jname:'',}];
        this.opdade[3] = [{id:'',jname:'',}];
        this.opdade[4] = [{id:'',jname:'',}];
        this.opdade[5] = [{id:'',jname:'',}];
        this.opdadeval[0]['valid'] = '';
      }
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlistuserget?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades.company_id = backdata.data[0];
          this.options1 = backdata.data[1];
          this.cs = backdata.data[2];
          this.opdade[0] = backdata.data[4];
      });
      this.$Loading.finish();
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jurisdiction?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jurisdiction?search='+ this.search + '&id=1' +'&company='+this.value +'&company1='+this.value2+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          // this.$set(this,'desserts',backdata.data[0]);
      });
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/Jindexsuserdel',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 1){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/Jurisdiction?id=1'+ '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+'&t='+t,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },
   watch: {
    '$route' (to, from) { //监听路由是否变化
      //加载公司列表
      this.$myhttp.get('admin/getcompany',{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.options = backdata.data[0];
          this.options2 = backdata.data[1];
          this.idsa = backdata.data[2];
      });
      if(to.path == "/Jindex/JuserindexAdd"){
        // console.log(to.path);
        this.$Loading.start();
        this.$myhttp.get('admin/Jurisdiction?search='+ this.search + '&id=1' +'&company='+this.value +'&company1='+this.value2,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        });
      }
    }
  },
  // watch:{
      //监听公司的改变
      // 'dades.company_id'(val){
      //   var t = Date.parse(new Date()) / 1000;//时间戳
      //   this.$myhttp.get('admin/getJusercompany?id='+val+'&t='+t,{
      //   'Content-Type': 'application/json'
      //   }).then(backdata=>{ // 异步执行成功后
      //     this.dades.jurisdiction_id = "";
      //     this.options1 = backdata.data[0];
      //   });
      // }
  // },
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.gshu{
  margin-left: 10.5%;
  color: rgb(72, 201, 147);
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Jurisdiction/JuserindexAdd.vue